// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"793d5b1a","162":"77d43900","234":"f7ecd14d","453":"0034f5db"}[chunkId] + ".chunk.js";
};